import { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
// import {  } from "react-router-dom";

const ViewMappingOptions = () => {
    const param = useParams();
    const pubId = param?.pubId;
    const gamId = param?.gamId;
    const excIncStatus = param?.showGamMapping;

    const [status, setStatus] = useState(excIncStatus);

    const navigate = useNavigate();

    const handleGenerateList = () => {
        if (status !== "2") {
            navigate(`/gamsetting/list/inclusion_exclusion?inclusionStatus=${status}&gamAccountId=${gamId}&accountId=${pubId}`)
        }
    }

    return (
        <>
            <div style={{ background: "#f5f5f5", padding: "25px" }}>
                <h5 style={{ color: "#007bff" }}>View Mapping</h5>

                {/* ===== View Mapping =====  */}
                <Form.Group className="mt-4">
                    <Form.Label>Status</Form.Label>
                    <Form.Select value={status}
                        onChange={(e) => setStatus(e.target.value)}>
                        <option value="2">All</option>
                        <option value="0">Inclusion</option>
                        <option value="1">Exclusion</option>
                    </Form.Select>
                </Form.Group>

                <Button className="mt-4" onClick={handleGenerateList} >Generate List</Button>
            </div>
        </>
    );
}

export default ViewMappingOptions;